const resolveIsDev = () => {
    if (typeof __isDev__ !== 'undefined') {
        return Boolean(__isDev__);
    }
    if (typeof process !== 'undefined' && process.env?.NODE_ENV) {
        return process.env.NODE_ENV !== 'production';
    }
    return false;
};

const isDev = resolveIsDev();

export const logInfo = (...args: unknown[]): void => {
    if (isDev) {
        // eslint-disable-next-line no-console
        console.log(...args);
    }
};

export const logWarn = (...args: unknown[]): void => {
    if (isDev) {
        // eslint-disable-next-line no-console
        console.warn(...args);
    }
};

export const logError = (...args: unknown[]): void => {
    if (isDev) {
        // eslint-disable-next-line no-console
        console.error(...args);
    }
};
